import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { Layout } from '../../../Layout';
import * as styles from './ArrowControls.css';
import { Arrow } from './parts/Arrow';

interface IArrowControlsProps {
  disableLeft: boolean;
  disableRight: boolean;
  clickHandler?(direction: TDirection): void;
}

export const ArrowControls: React.StatelessComponent<IArrowControlsProps> = props => {
  const { disableLeft, disableRight, clickHandler } = props;

  return (
    <div className={styles['container']}>
      <Layout>
        <div className={styles['wrapper']}>
          <Arrow direction={-1} clickHandler={clickHandler} disabled={disableLeft} />
          <Arrow direction={1} clickHandler={clickHandler} disabled={disableRight} />
        </div>
      </Layout>
    </div>
  );
};
